import { render, staticRenderFns } from "./channel-post-menu.vue?vue&type=template&id=106e137e&scoped=true"
import script from "./channel-post-menu.vue?vue&type=script&lang=js"
export * from "./channel-post-menu.vue?vue&type=script&lang=js"
import style0 from "./channel-post-menu.vue?vue&type=style&index=0&id=106e137e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e137e",
  null
  
)

export default component.exports